var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ticket.device
    ? _c(
        "div",
        [
          _c("stepheader", { attrs: { step: _vm.step, ticket: _vm.ticket } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "body current",
              attrs: {
                id: "wizard2-p-0",
                role: "tabpanel",
                "aria-labelledby": "wizard2-h-0",
                "aria-hidden": "false",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm._v(
                    "\n             I dati in nostro possesso del device con IMEI/Seriale "
                  ),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.ticket.device.identificativoDevice)),
                  ]),
                  _vm._v(" sono i seguenti: "),
                  _c("br"),
                  _vm._v(
                    "\n             modello " +
                      _vm._s(_vm.ticket.device.brand.brand) +
                      " " +
                      _vm._s(_vm.ticket.device.modello.modello) +
                      " \n             "
                  ),
                  _vm.ticket.device.memoria
                    ? _c("span", [
                        _vm._v(
                          "\nmemoria " +
                            _vm._s(_vm.ticket.device.memoria.memoria) +
                            "\n\n             "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v("."),
                  _c("br"),
                  _vm._v(
                    "\n             Confermi la correttezza del device in tuo possesso ?\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("buttons", {
                attrs: { buttons: _vm.step.buttons },
                on: { action: _vm.fireaction },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }